import { render, staticRenderFns } from "./LargeDot.vue?vue&type=template&id=77c759f0&"
import script from "./LargeDot.vue?vue&type=script&lang=js&"
export * from "./LargeDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports